export function getMinFloat(value: number): number {
  const intValue = parseInt(value.toString(), 10);
  const digits = intValue.toString().length;
  return parseFloat('1e-' + (16 - digits));
}
